export const doubleEquals = (a: number, b: number, epsilon: number = Number.EPSILON): boolean => {
    return Math.abs(a - b) < epsilon;
};


export function ceilValue(value: string | number): string | null {
    if (!value) {
        value = "0";
    }
    let floatValue;
    if (typeof value === "string") {
        value = value.replace(".", "").replace(",", ".");
        floatValue = parseFloat(value);
    } else {
        floatValue = value;
    }

    floatValue = floatValue ? floatValue : 0.0;
    return (Math.round((floatValue + Number.EPSILON) * 100) / 100).toFixed(2).toString().replace(".", ",");
}